import React, { useEffect, useRef, useState } from 'react';
import Efct33 from '../../../acets/efectsfilters/33.png'
import Efct34 from '../../../acets/efectsfilters/34.png'
import Advogado from'../../../acets/adv.jpg'
import { useFont } from '../../../ContextFont';
import IcoEdit from'../../../acets/icon/edit.svg'

export default function Lay44(props) {
  const { imagens, handleDownloadImage } = useFont();
  const divRef = useRef(null);

  const [titulo, setTitulo]=useState('Rua Rui Barbosa, centro N80 Próximo ao Shopping')
  const [subtitulo,setSubtitulo]=useState('📱 077 7777-7777')
  const [modalData, setModaldata]=useState(false)
  const [numimg,setNumimg]=useState(9)

  useEffect(() => {
    // Atualiza os estados locais quando props.datal é alterado
  
  }, []); 
  
  return (
  
    <div className='w33 cell-tamanho90 center celular  b2 cont-circ7 bordaElements ma10b0'>
      <div className='p10 b2 w10 cont-circ50pc fb'>44</div>
      <div  className="w100 h40 column between" >
        <div ref={divRef} id="resultImg44"  className="w100 z15 h33" style={{ backgroundImage: `url('${Efct33}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',backgroundPosition:'center'}} >
          <div className="w100 z15 h40 " style={{ background: `linear-gradient(50deg, rgba(0.00, 0.00, 0.00, 0.00) -10.05%, ${props.trapColor} 110.78%)` }} >
              <div className='w100 h40 row center'>
              <div className="w90 h40 column center" style={{ width: `${props.boxtitlesize*1.9}px`}} >
              <label className='c1 fb p10 cen' style={{ fontSize: `${props.titlesize}px`}} >NOSSA LOCALIZAÇÃO!</label>
                <img src={Efct34} alt='logo' className='w20'/>
                <label className='c3 w90 p10 cen'  style={{ fontSize: `${props.subtitlesize}px`, color: props.textColor }}>{titulo}</label>
                <label className='c3 fw500 p7 cen' style={{ fontSize: `${props.subtitlesize}px`, color: props.subtextColor }}>{subtitulo}</label>
                <div className='w30 row' >
               
                </div>
              </div>
            
            { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
              <label>Subtitulo</label>
              <input type='text' value={subtitulo} onChange={(e)=>setSubtitulo(e.target.value)}/>
            </div>
            }
             </div>
            </div>
           
           
          </div>
        </div>

      <div className="w100 he20 overflowY">
          <div className="w100 row between ma5">
            <div className="row w50">
              <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais' />
            </div>
            <div className="w50 row between">
             
            </div>
          </div>
          <label className="fs08em">{props.datal.legenda}</label>
          <div>
            <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
          </div>
      </div>
      <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10" 
          onClick={() => handleDownloadImage('resultImg44')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 
      
    </div>
  )
}

